import React from 'react';
import { FormMethod } from './FormMethod';
import { Dialog } from 'primereact/dialog';
import { Button } from 'reactstrap';

import '../methods/styleModal.css'


export const ModalMethod = (props) => {
    const {
        modal, modalTitle, toggle, method,
        validaciones,
        name, code,
        handleInputChange, loading,
        saveCreate, saveUpdate
    } = props;

    return (

        <Dialog
            visible={modal}
            modal
            closable={false}
            onHide={toggle}
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="fa fa-compass"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v`}
            footer={
                <>
                    {
                        method === "create" && <Button
                            color="secondary"
                            size="sm"
                            onClick={saveCreate}
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                        >
                            Crear método
                        </Button>
                    }
                    {
                        method === "update" && <Button
                            color="secondary"
                            size="sm"
                            onClick={saveUpdate}
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                        >
                            Actualizar método
                        </Button>
                    }

                    <Button size="sm" color='danger' type="button" onClick={toggle}>
                        {"Cancelar"}
                    </Button>

                </>
            }

        >
            {method === "create" ? (
                <FormMethod
                    button="Crear método"
                    {...{ toggle, loading, handleInputChange, validaciones, methodAction: saveCreate }}
                />
            ) : method === "update" ? (
                <FormMethod
                    button="Actualizar método"
                    {...{ toggle, loading, handleInputChange, name, code, validaciones, methodAction: saveUpdate }}
                />
            ) : null}
        </Dialog>



    );
};